// @flow
import React, { Component } from 'react';
import queryString from 'query-string';
import { type Location, type Match, type RouterHistory, withRouter } from 'react-router-dom';
import ResetForm from 'components/reset/ResetForm';
import { connect } from 'react-redux';
import type { State } from 'store';
import type { AuthResult } from 'store/modules/auth';
import {AuthActions, BaseActions, CartActions, WishActions, UserActions} from 'store/actionCreators';
import storage, { keys } from 'lib/storage';
import { pressedEnter } from 'lib/common';

type Props = {
  password1: string,
  password2: string,
  match: Match,
  location: Location,
  history: RouterHistory,
  authResult: AuthResult,
  error: ?{
    name: string,
    payload: any,
  },
};

class ResetFormContainer extends Component<Props> {
  initialize = async () => {
    const { history } = this.props;
    const { search } = this.props.location;
    const { code } = queryString.parse(search);

    if (!code) {
      history.push('/');
      return;
    }

    try {
      await AuthActions.codeLogin(code);
      const { authResult } = this.props;

      if (!authResult) return;
      const { user } = authResult;

      UserActions.setUser(user);
      await CartActions.getCart();
      await WishActions.getWish();
      storage.set(keys.user, user);
    } catch (e) {
      history.push('/error?code=409&message=인증 기간이 만료되었거나 사용한 이메일입니다.');
    }
  };

  componentDidMount() {
    this.initialize();
  }

  onChange = (e: SyntheticInputEvent<HTMLInputElement>): void => {
    const { value, name } = e.target;
    AuthActions.changeResetForm({
      name,
      value,
    });
  };

  onReset = async () => {
    const { password1, password2, history } = this.props;

    if (password1.length < 6 || password1.length > 30) {
      AuthActions.setError({ name: 'FIELD_RULE', payload: 'password1' });
      return;
    }

    if (password1 !== password2) {
      AuthActions.setError({ name: 'FIELD_RULE', payload: 'password2' });
      return;
    }

    try {
      await AuthActions.changePassword(password1);
      await UserActions.logout();
      storage.remove(keys.user);
      history.push('/login');
      BaseActions.showToast({
        message: '비밀번호가 변경되었습니다.',
        type: 'success',
      });
    } catch (e) {
      console.log(e);
    }
  };

  onEnterKeyPress = pressedEnter(() => {
    this.onReset();
  });

  render() {
    const { onChange, onReset, onEnterKeyPress } = this;
    const { password1, password2, error } = this.props;

    return (
      <ResetForm
        onChange={onChange}
        onReset={onReset}
        password1={password1}
        password2={password2}
        error={error}
        onEnterKeyPress={onEnterKeyPress}
      />
    );
  }
}

export default connect(
  ({ auth }: State) => {
    const {
      resetForm,
      authResult,
      error,
      nextUrl,
    } = auth;
    const { password1, password2 } = resetForm;

    return {
      password1,
      password2,
      authResult,
      error,
      nextUrl,
    };
  },
  () => ({}),
)(withRouter(ResetFormContainer));



// WEBPACK FOOTER //
// ./src/containers/reset/ResetFormContainer.js